const roleConstants = {
    USER_ROLE: "USER",
    ADMIN_ROLE: "ADMIN",
    TESTER_ROLE: "TESTER",
};

export default roleConstants;